import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { AppProviders } from '@app/providers/AppProviders';
import { initSentry } from '@app/providers/sentry';
import { initFeatureFlags } from '@app/providers/featureFlags';
import { reportWebVitals } from '@app/providers/observability';
import { router } from '@app/router/router';
import { isMockingEnabled } from '@shared/config/env';
import './styles/index.css';

void initSentry();
initFeatureFlags();

async function enableMocking(): Promise<void> {
  if (!isMockingEnabled) return;
  const { worker } = await import('@shared/api/mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

function mount(): void {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element #root not found');
  createRoot(rootEl).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
  reportWebVitals();
}

void enableMocking().then(mount);
